import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import layout from '@/layout/index';

const routes = [
  {
    name: 'notFound',
    path: '/:catchAll(.*)',
    redirect: {
      path: '/page/product'
    },
    meta: {
      title: '聪惠保'
    }
  },
  {
    name: 'page',
    path: '/page',
    component: layout,
    redirect: {
      path: '/page/index'
    },
    children: [
      {
        name: 'index',
        path: 'index',
        meta: {
          title: '首页',
          keepAlive: true,
          needFooter: true,
          showBubble:true,
        },
        component: () => import('@/view/home/index.vue')
      },
      {
        name: 'infomationInfo',
        path: 'infomationInfo',
        meta: {
          title: '资讯详情',
        },
        component: () => import('@/view/home/infomation/infomationInfo.vue')
      },
      {
        name: 'insuranceCardList',
        path: 'insuranceCardList',
        meta: {
          title: '权益卡列表',
        },
        component: () => import('@/view/home/insuranceCard/insuranceCardList.vue')
      },
      {
        name: 'insuranceCardDetail',
        path: 'insuranceCardDetail',
        meta: {
          title: '权益卡详情',
        },
        component: () => import('@/view/home/insuranceCard/insuranceCardDetail.vue')
      },{
        name: 'insuranceCardOrder',
        path: 'insuranceCardOrder',
        meta: {
          title: '权益卡订单',
        },
        component: () => import('@/view/home/insuranceCard/insuranceCardOrder.vue')
      },
      {
        name: 'product',
        path: 'product',
        meta: {
          title: '产品',
          keepAlive: true,
          needFooter: true,
          showBubble:true,
        },
        component: () => import('@/view/product/index.vue')
      },
      {
        name: 'posterPic',
        path: 'product/posterPic',
        meta: {
          title: '产品海报'
        },
        component: () => import('@/view/product/posterPic/index.vue')
      },
      {
        name: 'mine',
        path: 'mine',
        meta: {
          title: '我的',
          needFooter: true,
          keepAlive: true,
          showBubble:true,
        },
        component: () => import('@/view/mine/index.vue')
      },
      {
        name: 'login',
        path: '/login',
        component: () => import('@/view/login.vue'),
        meta: {
          title: '登录'
        }
      },
      {
        name: 'resetPwd',
        path: '/resetPwd',
        component: () => import('@/view/resetPassword.vue'),
        meta: {
          title: '重置密码'
        }
      },
      {
        name: 'share',
        path: '/share',
        component: () => import('@/view/share.vue'),
        meta: {
          title: '加载中...'
        }
      },
      {
        name: 'register',
        path: '/register',
        component: () => import('@/view/register.vue'),
        meta: {
          title: '注册'
        }
      },
      {
        name: 'huanYing',
        path: '/huanYing',
        component: () => import('@/view/huanYing.vue'),
        meta: {
          title: '注册'
        }
      },
      {
        name: 'infoRegist',
        path: '/infoRegist',
        component: () => import('@/view/infoRegist.vue'),
        meta: {
          title: '信息收录'
        }
      },
      {
        name: 'infoRegistTuanCai',
        path: '/infoRegistTuanCai',
        component: () => import('@/view/infoRegistTuanCai.vue'),
        meta: {
          title: '信息收录'
        }
      },
      {
        name: 'wxAuthor',
        path: '/wxAuthor',
        component: () => import('@/view/wxAuthor.vue'),
        meta: {
          title: '微信授权'
        }
      },
      {
        name: 'webdiv',
        path: '/webdiv',
        component: () => import('@/view/common/webview/index.vue')
      },

      {
        name: '订单详情',
        path: '/orderDetail',
        meta: {
          title: '订单详情'
        },
        component: () => import('@/components/orderDetail/index.vue')
      },
      {
        name: 'policyDetail',
        path: '/policyDetail',
        meta: {
          title: '保单详情'
        },
        component: () => import('@/components/policyDetail/index.vue')
      },
      {
        name: 'orderIncome',
        path: '/policyDetail/orderIncome',
        meta: {
          title: '保单收益'
        },
        component: () => import('@/components/policyDetail/orderIncome/index.vue')
      },
      {
        name: 'orderCorrect',
        path: '/policyDetail/orderCorrect',
        meta: {
          title: '保单批改记录'
        },
        component: () => import('@/components/policyDetail/orderCorrect/index.vue')
      },
      {
        name: 'renewalList',
        path: '/renewalList',
        meta: {
          title: '续期列表'
        },
        component: () => import('@/components/renewalList/index.vue')
      },
      {
        name: 'jieSuan',
        path: '/mine/jieSuan',
        meta: {
          title: '收入明细',
          keepAlive: true
        },
        component: () => import('@/view/mine/jieSuan/index.vue')
      },
      {
        name: 'tiXian',
        path: '/mine/tiXian',
        meta: {
          title: '提现'
        },
        component: () => import('@/view/mine/tiXian/index.vue')
      }, {
        name: 'tiXianJiLv',
        path: '/mine/tiXian/tiXianJiLv',
        meta: {
          title: '提现记录'
        },
        component: () => import('@/view/mine/jieSuan/tiXianJiLv.vue')
      },
      {
        name: '待完成',
        path: '/mine/daiWanCheng',
        meta: {
          title: '待完成'
        },
        component: () => import('@/view/mine/daiWanCheng/index.vue')
      },
      {
        name: '待支付',
        path: '/mine/daiZhiFu',
        meta: {
          title: '待支付'
        },
        component: () => import('@/view/mine/daiZhiFu/index.vue')
      },
      {
        name: 'yiWanCheng',
        path: '/mine/yiWanCheng',
        meta: {
          title: '已完成',
          keepAlive: true
        },
        component: () => import('@/view/mine/yiWanCheng/index.vue')
      },
      {
        name: 'zengYuanYaoQing',
        path: '/mine/zengYuanYaoQing',
        meta: {
          title: '增员邀请'
        },
        component: () => import('@/view/mine/zengYuanYaoQing/index.vue')
      },
      {
        name: 'baoDan',
        path: '/mine/baoDan',
        meta: {
          title: '保单',
          keepAlive: true
        },
        component: () => import('@/view/mine/baoDan/index.vue')
      },
      {
        name: 'piGai',
        path: '/mine/piGai',
        meta: {
          title: '保全变更',
          keepAlive: true
        },
        component: () => import('@/view/mine/piGai/index.vue')
      },
      {
        name: 'shouHouZhiYin',
        path: '/mine/baoDan/shouHouZhiYin',
        meta: {
          title: '售后指引'
        },
        component: () => import('@/view/mine/baoDan/shouHouZhiYin/index.vue')
      },{
        name: 'liPeiFuWu',
        path: '/mine/liPeiFuWu',
        meta: {
          title: '理赔服务'
        },
        component: () => import('@/view/mine/liPeiFuWu/index.vue')
      },
      {
        name: 'zhiZhiBaoDan',
        path: '/mine/zhiZhiBaoDan',
        meta: {
          title: '纸质保单'
        },
        component: () => import('@/view/mine/zhiZhiBaoDan/index.vue')
      }, {
        name: 'yuYue',
        path: '/mine/yuYue',
        meta: {
          title: '预约单'
        },
        component: () => import('@/view/mine/yuYue/index.vue')
      },
      {
        name: 'youJiDiZhi',
        path: '/mine/zhiZhiBaoDan/youJiDiZhi',
        meta: {
          title: '邮寄地址'
        },
        component: () => import('@/view/mine/zhiZhiBaoDan/youJiDiZhi/index.vue')
      },
      {
        name: 'huiZhiHuiFang',
        path: '/mine/huiZhiHuiFang',
        meta: {
          title: '回执回访',
          keepAlive: true
        },
        component: () => import('@/view/mine/huiZhiHuiFang/index.vue')
      },
      {
        name: 'danLu',
        path: '/mine/danLu',
        meta: {
          title: '单录',
          keepAlive: true
        },
        component: () => import('@/view/mine/danLu/index.vue')
      },
      {
        name: 'xuBaoXuQi',
        path: '/mine/xuBaoXuQi',
        meta: {
          title: '续保续期',
          keepAlive: true
        },
        component: () => import('@/view/mine/xuBaoXuQi/index.vue')
      },
      {
        name: 'setting',
        path: '/mine/setting',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/mine/setting.vue')
      },
      {
        name: 'changePassword',
        path: '/mine/setting/changePassword',
        meta: {
          title: '修改密码'
        },
        component: () => import('@/view/mine/setting/changePassword.vue')
      },
      {
        name: 'qianYue',
        path: '/mine/setting/qianYue',
        meta: {
          title: '绑定银行卡'
        },
        component: () => import('@/view/mine/setting/qianYue.vue')
      },
      {
        name: 'tuanDui',
        path: '/mine/tuanDui',
        meta: {
          title: '团队管理'
        },
        component: () => import('@/view/mine/tuanDui/index.vue')
      }, {
        name: 'jiXuLv',
        path: '/mine/jiXuLv',
        meta: {
          title: '长险继续率'
        },
        component: () => import('@/view/mine/jiXuLv/index.vue')
      }, {
        name: 'fangKeZhuiZong',
        path: '/mine/fangKeZhuiZong',
        meta: {
          keepAlive: true,
          title: '访客追踪'
        },
        component: () => import('@/view/mine/fangKeZhuiZong/index.vue')
      }, {
        name: 'fangkeForProduct',
        path: '/mine/fangKeZhuiZong/fangkeForProduct',
        meta: {
          title: '访客追踪'
        },
        component: () => import('@/view/mine/fangKeZhuiZong/fangkeForProduct/index.vue')
      }, {
        name: 'fangkeForVister',
        path: '/mine/fangKeZhuiZong/fangkeForVister',
        meta: {
          title: '访客追踪'
        },
        component: () => import('@/view/mine/fangKeZhuiZong/fangkeForVister/index.vue')
      }, {
        name: 'microstore',
        path: '/mine/microstore',
        meta: {
          title: '我的微店',
          keepAlive: true
        },
        component: () => import('@/view/mine/microstore/index.vue')
      }, {
        name: 'shareSetting',
        path: '/mine/microstore/shareSetting',
        meta: {
          title: '分享设置',
        },
        component: () => import('@/view/mine/microstore/shareSetting.vue')
      },{
        name: 'microstoreProduct',
        path: '/mine/microstore/microstoreProduct',
        meta: {
          title: '产品管理'
        },
        component: () => import('@/view/mine/microstore/microstoreProduct.vue')
      }, {
        name: 'addMicrostoreProduct',
        path: '/mine/microstore/microstoreProduct/addMicrostoreProduct',
        meta: {
          title: '编辑产品'
        },
        component: () => import('@/view/mine/microstore/addMicrostoreProduct.vue')
      }, {
        name: 'updateMicrostoreProduct',
        path: '/mine/microstore/microstoreProduct/updateMicrostoreProduct',
        meta: {
          title: '编辑产品'
        },
        component: () => import('@/view/mine/microstore/updateMicrostoreProduct.vue')
      }, {
        name: 'microstoreView',
        path: '/microstore/:microstore',
        redirect: to => {
          const { microstore } = to.params;
          return `/microstore/${microstore}/product`;
        },
        component: () => import('@/view/mine/microstore/view/product.vue')
      }, {
        name: 'microstoreIndex',
        path: '/microstore/:microstore/index',
        component: () => import('@/view/mine/microstore/view/index.vue')
      }, {
        name: 'microstoreProductView',
        path: '/microstore/:microstore/product',
        component: () => import('@/view/mine/microstore/view/product.vue')
      }, {
        name: 'microstoreBanner',
        path: '/mine/microstore/microstoreBanner',
        meta: {
          title: 'Banner管理'
        },
        component: () => import('@/view/mine/microstore/banner/index.vue')
      }, {
        name: 'microstoreAddBanner',
        path: '/mine/microstore/microstoreBanner/add',
        meta: {
          title: 'Banner管理'
        },
        component: () => import('@/view/mine/microstore/banner/addBanner.vue')
      }, {
        name: 'microstoreToolbar',
        path: '/mine/microstore/microstoreToolbar',
        meta: {
          title: '工具栏'
        },
        component: () => import('@/view/mine/microstore/toolbar/index.vue')
      }, {
        name: 'microstoreAddToolbar',
        path: '/mine/microstore/microstoreToolbar/add',
        meta: {
          title: '工具栏'
        },
        component: () => import('@/view/mine/microstore/toolbar/addToolbar.vue')
      },
      {
        name: 'quanyika',
        path: '/mine/quanyika',
        meta: {
          title: '订单列表'
        },
        component: () => import('@/view/mine/quanyika/index.vue')
      },
      {
        name: 'buyer',
        path: '/quanyika',
        meta: {
          title: '订单列表'
        },
        component: () => import('@/view/mine/quanyika/buyer.vue')
      },
      {
        name: 'quanyikaDetail',
        path: '/mine/quanyikaDetail/:orderNo',
        meta: {
          title: '订单详情'
        },
        component: () => import('@/view/mine/quanyika/OrderDetail.vue')
      },

    ]
  }
];

const router = createRouter({
  routes,
  history: createWebHistory()
});

export { router };
